import _ from 'lodash';
import moment from 'moment';
import { getField, updateField } from 'vuex-map-fields';

const state = {
    tabsStatusList: [
        {
            status: true,
            percent: 25,
            label: 'Comprador'
        },
        // {
        //     status: false,
        //     percent: 25,
        //     label: 'Vendedor'
        // },
        {
            status: false,
            percent: 25,
            label: 'Peritaje'
        },
        {
            status: false,
            percent: 25,
            label: 'Pago'
        },
        {
            status: false,
            percent: 25,
            label: 'Venta'
        },
    ],
    curent_proceso: 'Comprador',
    id_proceso: '',
    fecha_proceso: '',
    slug_proceso: '',
    vender: {
        id_venta: '',
        comprador: {
            nombre: '',
            apellido: '',
            tipo_documento: '',
            numero_documento: '',
            celular: '',
            correo: '',
            ubicacion_id: '',
            ubicacion_name: '',
            direccion: '',
            tiene_antecedentes: 'No',
            tiene_multas: 'No',
            valor_multas: '0'
        },
        negocio: {
            precio_publicacion: 0,
            tipo_pago: [],
            comprador: {
                descuento: 0,
                precio_compra: 0,
                forma_pago: ""
            },
            vendedor: {
                descuento: 0,
                precio_venta: 0,
                forma_pago: ""
            }
        },
        vehiculo: {
            fecha_peritaje: '',
            empresa_peritaje: '',
            peritaje_link: ''
        },
        id_asesor: '',
        id_sede: '',
        vendedor: 'propietario',
        id_sede: '',
        vendedorData: {
            nombre: '',
            apellido: '',
            celular: '',
            correo: '',
            ubicacion_id: '',
            ubicacion_name: '',
            direccion: '',
            tipo_documento: '',
            numero_documento: ''
        },
        compradores: [],
        cedula_comprador_link: '',
        openModalComprador: true,
    }
};
const mutations = {
    updateField,
    updateFichaVenta: (state, payload) => {
        // console.log(payload)
        state.id_proceso = payload._id;
        state.slug_proceso = 'fichaVenta';
        const createdFormat = moment(payload.created_at).format('DD-MM-YYYY hh:mm A');
        state.fecha_proceso = createdFormat;
        state.info_proceso = {
            ...state.info_proceso,
            cliente: { ...payload.cliente },
            asesor: { ...payload.asesor },
            vehiculo: { ...payload.vehiculo },
            foto_principal: payload.foto_principal
        }

        state.tabs_status = [...payload.tabs_status];
        state.historial = [...payload.historial];

        state.proceso = {
            ...state.proceso,
            ...payload.proceso
        };

        state.vender.negocio.precio_publicacion = payload.vehiculo.precio_publicacion;
        state.vender.vendedorData = [
            {
                tipo: "propietario",
                nombre: payload.proceso.inspeccion_legal.propietario.propietario_nombre,
                apellido: payload.proceso.inspeccion_legal.propietario.propietario_apellido,
                celular: payload.proceso.inspeccion_legal.propietario.propietario_tel,
                correo: payload.proceso.inspeccion_legal.propietario.propietario_email,
                ubicacion_id: payload.proceso.inspeccion_legal.propietario.propietario_ubicacion._id,
                ubicacion_name: payload.proceso.inspeccion_legal.propietario.propietario_ubicacion.ciudad + ' - ' + payload.proceso.inspeccion_legal.propietario.propietario_ubicacion.depto,
                direccion: payload.proceso.inspeccion_legal.propietario.propietario_direccion,
                tipo_documento: payload.proceso.inspeccion_legal.propietario.propietario_tipo_id,
                numero_documento: payload.proceso.inspeccion_legal.propietario.propietario_number_id,
                runt: payload.proceso.inspeccion_legal.propietario.estado_propietario_runt,
                antecedentes: payload.proceso.inspeccion_legal.propietario.tiene_antecedentes,
                multas: payload.proceso.inspeccion_legal.propietario.tiene_multas,
                vr_multas: payload.proceso.inspeccion_legal.propietario.multas_valor
            }
        ];
    },
};

const getters = {
    getField,
};

export default {
    namespaced: true,
    state,
    mutations,
    getters
}
